import React, { useEffect } from 'react';

import UalaLogo from '../images/imagotipo.svg';
import { StyledDots, StyledSplashContainer } from './styles';

const Splash: React.FC<{ show: boolean }> = ({ show }) => {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.removeProperty('overflow');
    };
  }, [show]);

  if (!show) return null;
  return (
    <StyledSplashContainer data-testid="splash">
      <img src={UalaLogo} alt="" />
      <StyledDots />
    </StyledSplashContainer>
  );
};

export default Splash;
